// validate.js
// Универсальные утилиты
export const digitsOnly = (value) => value ? value.replace(/\D/g, "") : "";

export const formatPhoneForServer = digitsOnly;
export const formatOtpForServer = digitsOnly;

// Валидация телефона
export const validatePhone = (phone, t) => {
  const errors = {};
  const digits = digitsOnly(phone);

  if (!phone || phone.trim() === "") {
    errors.phone = t("ENTER_PHONE_NUMBER");
  } else if (digits.length < 12) {
    errors.phone = t("NOT_FULL_PHONE_NUMBER");
  } else if (!digits.startsWith("998")) {
    errors.phone = t("NUMBER_SHOULD_START") + " +998";
  } else if (digits.length > 12) {
    errors.phone = t("TOO_LONG_NUMBER");
  }

  return errors;
};

// Валидация OTP
export const validateOtp = (otp, t) => {
  const errors = {};
  const digits = digitsOnly(otp);

  if (!otp || otp.trim() === "") {
    errors.otp = t("ENTER_SMS");
  } else if (digits.length < 5) {
    errors.otp = t("OTP_SHORT"); // строка перевода
  } else if (digits.length > 5) {
    errors.otp = t("OTP_TOO_LONG"); // строка перевода
  }

  return errors;
};

// Валидация пароля
export const validatePassword = (password, confirmPassword, t) => {
  const errors = {};

  if (!password) {
    errors.password = t("ENTER_PASSWORD");
  } else if (password.length < 8) {
    errors.password = t("PASSWORD_TOO_SHORT");
  }

  if (!confirmPassword) {
    errors.confirmPassword = t("CONFIRM_PASSWORD");
  } else if (password !== confirmPassword) {
    errors.confirmPassword = t("PASSWORDS_NOT_MATCH");
  }

  return errors;
};

// Валидация чекбоксов (согласие, возраст)
export const validateAgreements = (agreement, isAdult, t) => {
  const errors = {};

  if (!agreement) {
    errors.agreement = t("AGREEMENT_REQUIRED");
  }
  if (!isAdult) {
    errors.isadult = t("ADULT_REQUIRED");
  }

  return errors;
};

// Общая форма регистрации
export const validateRegisterForm = (formData, t) => {
  let errors = {};

  errors = {
    ...errors,
    ...validatePhone(formData.phone, t),
    ...validatePassword(formData.password, formData.confirmPassword, t),
    ...validateAgreements(formData.agreement, formData.isadult, t),
  };

  console.log(errors)

  return errors;
};
